import { useState, useEffect } from "react";
import { Params, Output } from "drawdown-web";
import Simulation from "./Simulation";
import SimulationInput, { status_table } from "./Input";
import "./App.css";
import { simToInputParams } from "./schemas";
import { worker } from "./index";

function App() {
  const [params, setParams] = useState<Params>({
    n_years: 45,
    n_adults: 2,
    child_births: [-16, -14, -12],
    start_age: 45,
    initial_stocks: {
      NormalDeposits: 300000,
      NormalGains: 375000,
      RothContrib: 225000,
      RothUnvested: 0,
      RothEarn: 150000,
      Trad: 650000,
    },
    spending: [
      80000, 120000, 120000, 165000, 165000, 155000, 155000, 105000, 105000,
      55000, 55000, 55000, 55000, 30000, 30000, 30000, 30000, 30000, 30000,
      35000, 35000, 35000, 35000, 35000, 35000, 35000, 35000, 35000, 35000,
      35000, 35000, 35000, 35000, 35000, 35000, 35000, 35000, 35000, 35000,
      35000, 35000, 35000, 35000, 35000, 35000,
    ],
    ira_eligible_spending: [
      0.0, 50000, 50000, 100000, 100000, 100000, 100000, 50000, 50000, 0.0, 0.0,
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
      0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0,
      0.0, 0.0, 0.0, 0.0,
    ],
    income: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    ],
    use_aca: [
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
    ],
    interest_rate: 0.03,
    fpl_table: [
      13590.0, 18310.0, 23030.0, 27750.0, 32470.0, 37190.0, 41910.0, 46630.0,
    ],
    minor_child_tax_credit_nonrefundible: 600.0,
    adult_child_tax_credit_nonrefundible: 500.0,
    ira_contribution_limit: 23500 +  2* 7000,
    ...status_table.mfj,
  });
  const [output, setOutput] = useState<Output | null>(null);
  useEffect(() => {
    worker.onmessage = (e) => {
      setOutput(e.data);
    };
    worker.postMessage(params);
  }, []);
  const handleParamsUpdate = (new_params: Params) => {
    setParams(new_params);
    setOutput(null);
    worker.postMessage(new_params);
  };
  return (
    <div className="App">
      <SimulationInput
        setParams={handleParamsUpdate}
        params={simToInputParams(params)}
      />
      <Simulation params={params} output={output} />
    </div>
  );
}

export default App;
